// @ts-nocheck

import { type BasketState } from '../../../../../states/basket';

const basketResetBoomActives = (state: BasketState): BasketState => {
  const { items } = state;

  return {
    ...state,
    isBoomActive: false,
    boom: null,
    items: Object.keys(items).reduce(
      (acc, key) => ({
        ...acc,
        [key]: {
          // $FlowFixMe
          ...items[key],
          isBoomActive: false,
          boom: null,
        },
      }),
      {},
    ),
  };
};

export default basketResetBoomActives;
